import React from 'react'
import { Link } from 'react-router-dom'
import { Box, makeStyles } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  topBox: {
    backgroundColor: `#FFF`,
    padding: `2.5rem 5rem 1rem`,
    width: `100%`,
    [theme.breakpoints.up('md')]: {
      padding: `2.5rem 8.125rem 1rem`,
    },
  },
  breadcrumbLink: {
    color: `#1E2553`,
    textDecoration: `none`,
    '&:hover': {
      textDecoration: `none`,
    },
  },
  crumb: {
    display: `inline`,
  },
  breadcrumbDivider: {
    color: `#009ECC`,
    display: `inline`,
  },
  backButton: {
    alignItems: `center`,
    color: `#1E2553`,
    display: `flex`,
    fontSize: `1rem`,
    lineHeight: `1.5rem`,
    marginTop: `1rem`,
    textDecoration: `none`,
    textTransform: `uppercase`,
    width: `5rem`,
    '&:hover': {
      textDecoration: `none`,
    },
  },
  backIcon: {
    height: `1rem`,
    lineHeight: `1.5rem`,
    marginRight: `-0.75rem`,
  },
  backText: {
    paddingLeft: `1rem`,
  },
}))

const Breadcrumbs = ({ crumbs }) => {
  const classes = useStyles()

  return (
    <Box className={classes.topBox}>
      <Box className={classes.breadcrumbs}>
        <Link to="/" className={classes.breadcrumbLink}>
          Home
        </Link>
        {crumbs.map((crumb, key) => (
          <Box className={classes.crumb} key={key}>
            <Box className={classes.breadcrumbDivider}>&nbsp;&nbsp;&gt;&gt;&nbsp;&nbsp;</Box>
            <Link to={crumb.path} className={classes.breadcrumbLink}>
              {crumb.text}
            </Link>
          </Box>
        ))}
      </Box>
      <Link to="/" className={classes.backButton}>
        <ArrowBackIosIcon className={classes.backIcon} />
        <ArrowBackIosIcon className={classes.backIcon} />
        <span className={classes.backText}>Back</span>
      </Link>
    </Box>
  )
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array.isRequired,
}

export default Breadcrumbs
